import { useTranslation } from 'react-i18next'

const AssetNoAccount = () => {
  const { t } = useTranslation('wallet', { keyPrefix: 'assetList' })

  return (
    <div className='flex flex-col items-center justify-center py-6 rounded bg-paper-muted'>
      <div className='text-main-muted text-lg font-semibold'>
        {t('noAccount')}
      </div>
      <div className='mt-3 text-main-muted text-sm text-center'>
        {t('noAccountSuggestion')}
      </div>
    </div>
  )
}

export default AssetNoAccount
